module.exports = __webpack_public_path__ + "static/media/04.9769a7c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/04.jpg
// module id = 311
// module chunks = 0